import {storyblokEditable} from "@storyblok/react";

import {transformImage} from "../../utils/StoryblokService";
import Image from "next/image";
//import Lightbox from "./Lightbox";
import {IStoryblokImage} from "../../types/IStoryblokImage";
import Lightbox from "./Lightbox";
import React from "react";
import GalleryImage from "./GalleryImage";

var classNames = require('classnames');


export default function Gallery(props: any) {
    const blok = props.blok;
    const letTailwindKnow = ['md:grid-cols-4 md:grid-cols-3']

    return <section className={"overflow-hidden text-gray-700 " + props.blok.class} {...storyblokEditable(blok)}>
        <div className="mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8 py-16">
            <div className="lg:text-center">
                <h2 className="text-lg font-semibold text-green">
                    {blok.intro}
                </h2>
                <p className="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
                    {blok.title}
                </p>
                <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
                    {blok.subtitle}
                </p>
            </div>


            {blok.type !== 'Masonry' &&
                <div
                    className={classNames(blok.type, "gap-4 lg:gap-8 mt-10")}
                >
                    {blok.images.map((el: IStoryblokImage) => {
                        return <GalleryImage key={el.id} el={el}
                                             imagesize={blok.imagesize}
                                             lightbox={blok.lightbox}
                                             shadow={blok.shadow}/>
                    })}
                </div>}

            {blok.type === 'Masonry' &&
                <div className="flex flex-wrap mt-10">
                    <div className="flex flex-wrap w-1/2">
                        <div className="w-1/2 p-1 md:p-2">
                            {blok.images[0] &&
                                <Image
                                    src={transformImage(blok.images[0].filename, "456x384")}
                                    className={"w-full rounded-lg shadow"}
                                    alt={blok.images[0].alt}
                                    width={456}
                                    height={384}
                                />}
                        </div>
                        <div className="w-1/2 p-1 md:p-2">
                            {blok.images[1] &&
                                <Image
                                    src={transformImage(blok.images[1].filename, "456x384")}
                                    className={"w-full rounded-lg shadow"}
                                    alt={blok.images[1].alt}
                                    width={456}
                                    height={384}
                                />}
                        </div>
                        <div className="w-full p-1 md:p-2">
                            {blok.images[2] &&
                                <Image
                                    src={transformImage(blok.images[2].filename, "1200x1000")}
                                    className={"w-full rounded-lg shadow"}
                                    alt={blok.images[2].alt}
                                    width={1200}
                                    height={1000}
                                />}
                        </div>
                    </div>
                    <div className="flex flex-wrap w-1/2">
                        <div className="w-full p-1 md:p-2">
                            {blok.images[3] &&
                                <Image
                                    src={transformImage(blok.images[3].filename, "1200x1000")}
                                    className={"w-full rounded-lg shadow"}
                                    alt={blok.images[3].alt}
                                    width={1200}
                                    height={1000}
                                />}
                        </div>
                        <div className="w-1/2 p-1 md:p-2">
                            {blok.images[4] &&
                                <Image
                                    src={transformImage(blok.images[4].filename, "456x384")}
                                    className={"w-full rounded-lg shadow"}
                                    alt={blok.images[4].alt}
                                    width={456}
                                    height={384}
                                />}
                        </div>
                        <div className="w-1/2 p-1 md:p-2">
                            {blok.images[5] &&
                                <Image
                                    src={transformImage(blok.images[5].filename, "456x384")}
                                    className={"w-full rounded-lg shadow"}
                                    alt={blok.images[5].alt}
                                    width={456}
                                    height={384}
                                />}
                        </div>
                    </div>
                </div>}
        </div>
    </section>;
}